import { render } from "./nirmalSathai.vue?vue&type=template&id=2f666768"
import script from "./nirmalSathai.vue?vue&type=script&lang=js"
export * from "./nirmalSathai.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__